import { type ReadCallback } from 'i18next';

import { ContentfulBackend } from '@soluto-private/mx-i18n';

const getStorageKey = (language: string, namespace: string) =>
  `@translation:${namespace}|${language}`;

export const FallbackBackendInit = (fallbackTranslationsUrl: string) => {
  return class FallbackBackend extends ContentfulBackend {
    read(language: string, namespace: string, callback: ReadCallback) {
      super.read(language, namespace, async (err, data) => {
        if (!data || Object.keys(data).length === 0) {
          const storedTranslations = sessionStorage.getItem(
            getStorageKey(language, namespace)
          );
          if (storedTranslations) {
            const translations = JSON.parse(storedTranslations);
            if (Object.keys(translations).length > 0) {
              return callback(null, translations);
            }
          }
          return callback(
            null,
            await (await fetch(fallbackTranslationsUrl)).json()
          );
        } else {
          sessionStorage.setItem(
            getStorageKey(language, namespace),
            JSON.stringify(data)
          );
        }
        return callback(err, data);
      });
    }
  };
};
